import MapFieldListState from '../interfaces/states/MapFieldListState';

import * as Const from '../constants';

const initState: MapFieldListState = {
  isError: false,
  isLoading: false,
  mapFieldList: {},
  mapFieldListOrder: [],
  currentId: null,
  currentDrawLayer: null,
  currentCenter: null,
};

export default function mapFieldList (state: MapFieldListState = initState, action): MapFieldListState {
  switch (action.type) {

    case Const.FETCH_MAP_FIELD_LIST_INIT:
      return {
        ...initState,
        isLoading: false,
      };

    case Const.FETCH_MAP_FIELD_LIST_PENDING:
      return {
        ...state,
        isLoading: true,
        isError: false,
      };

    case Const.FETCH_MAP_FIELD_LIST_SUCCESS:
      return {
        ...state,
        mapFieldList: action.payload,
        isLoading: false,
        isError: false,
      };

    case Const.FETCH_MAP_FIELD_LIST_ERROR:
      return {
        ...state,
        isLoading: false,
        isError: true,
      };

    case Const.FETCH_MAP_FIELD_LIST_ORDER:
      return {
        ...state,
        mapFieldListOrder: action.payload.sort((a, b) => a - b),
        currentId: action.payload[0],
        isLoading: false,
        isError: false,
      };

    case Const.SET_CURRENT_DRAW_LAYER:
      return {
        ...state,
        currentDrawLayer: action.payload,
      };

    case Const.SET_CURRENT_CENTER:
      return {
        ...state,
        currentCenter: action.payload,
      };

    default:
      return state;
  }
}
